import axios from './Api';

export function GetCounties() {
  return axios.get<Utils.ICounty[]>('/util/counties');
}

export function GetLocalities(params = {}) {
  return axios.get<Locality.ILocality[]>('/util/localities', { params });
}

export function GetMonths() {
  return axios.get<[keyof Month.IGetMonths]>('/util/aidMonths');
}

export function SearchCityHall(search = '') {
  return axios.get<Utils.ICityHall[]>('/util/cityHall', { params: { search } });
}

export function SearchCRC() {
  return axios.get<Utils.ICRC[]>('/util/crc', { params: {} });
}

export function SearchCounties() {
  return axios.get<Utils.ICounty[]>('/util/counties', { params: {} });
}

export function GetMonthsBlock() {
  return axios.get<[keyof Month.IGetMonths]>('/util/aidMonthsBlock');
}